/* v8 ignore start -- @preserve */

export const screens = {
  "2xl": "1536px",
  "3xl": "1728px",
  lg: "1024px",
  md: "841px",
  sm: "640px",
  xl: "1280px",
  xs: "320px",
} as const;

export type TailwindBreakpoints = keyof typeof screens;
